import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/sampleTime';
import 'rxjs/add/operator/share';
import 'rxjs/add/observable/empty';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


// Only create one scroll listener per target and share the observable.
// Typical, there will only be one observable per application

@Injectable()
export class ScrollListener{
    public scrollListeners = {};

    public getScrollListener = (scrollTarget?: any): Observable<any> => {
        if (!scrollTarget || typeof scrollTarget.addEventListener !== 'function') {
            console.warn('`addEventListener` on ' + scrollTarget + ' (scrollTarget) is not a function. Skipping this target');
            return Observable.empty();
        }
        if (scrollTarget in this.scrollListeners) {
            return this.scrollListeners[scrollTarget];
        }

        const scrollEvent = Observable.create(observer => {
            const eventName = 'scroll';
            const handler = event => observer.next(event);
            const options = { passive: true, capture: false };
            scrollTarget.addEventListener(eventName, handler, options);
            return () => scrollTarget.removeEventListener(eventName, handler, options);
        });

        this.scrollListeners[scrollTarget] = scrollEvent
            .sampleTime(100)
            .share()
            .startWith('');
        return this.scrollListeners[scrollTarget];
    };
}




// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/scroller/scroll-listener.ts